<template>
    <v-col
        :cols="width"
    >
        <v-select
            :disabled="readonly"
            :items="item.props.items"
            :label="label_text"
            :persistent-hint="item.props.hint || thisArchivedSelection ? true : false"
            :hint="item.props.hint ? item.props.hint : thisArchivedSelection ? archivedSelectionText : ''"
            :multiple="item.props.multiple"
            :name="item.name"
            :rules="rules"
            ref="input"
            v-model="modelData"
            outlined
        >
            <template v-slot:message="{ message }">
                <div v-html="message"></div>
            </template>

            <template v-if="item.props.tooltip" v-slot:append-outer>
                <v-tooltip
                    top
                    max-width="620"
                >
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information</v-icon>
                    </template>
                    <div v-html="item.props.tooltip"></div>
                </v-tooltip>
            </template>
        </v-select>
    </v-col>
</template>
<script>
    export default {
        name: 'SelectList',
        props: {
            item: Object, 
            value: [Number, String, Object, Array],
            readonly: Boolean, 
            rules: Array,
            width: [String, Number],
            handleTabChange: Function
        },
        data () {
            return {
                label_text: this.item.props.label || (this.item.props.multiple ? 'Select all that Apply' : 'Please select an option')
            }
        },
        computed: {
            modelData: {
                get: function () {
                    const props = this.item && this.item.props;
                    const value = this.value;

                    // This handles the formatting if a selectlist changes from single to multiple with existing values
                    if (value !== undefined && props && props.multiple && !Array.isArray(value)) {
                        return [value];
                    }
                    
                    return value;
                },
                set: function (newVal) {
                    const maxItems = this.item.props && this.item.props.maxItems;

                    if (maxItems && newVal.length > parseInt(maxItems, 10)) {
                        return;
                    }

                    this.$emit('input', newVal);
                }
            },
            thisArchivedSelection: function() {
                if ( this.item.props.archivedoptions && this.modelData ) { 
                    if ( this.item.props.archivedoptions.filter(option => this.modelData.includes(option.value)).length > 0 ) {
                        let archivedText = this.item.props.archivedoptions.filter(option => this.modelData.includes(option.value));
                        this.label_text = `Please select ${this.item.props.multiple ? ` different options` : ` a different option`}`;

                        const option_delimiter = this.item.props.archivedoptions.length == 2 ? ' & ' : ', ';
                        archivedText = archivedText.map(option => option.text).join(option_delimiter);

                        return archivedText;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            archivedSelectionText: function() {
                let text = '';
                if ( this.thisArchivedSelection ) {
                    const selectionCount = this.item.props.archivedoptions.length > 1
                    text = `<span class="warning--text font-weight-thin">Your previous selection` + (selectionCount ? `s` : ``) + `, <span class="warning--text font-weight-bold">` + this.thisArchivedSelection + `</span>,` + (selectionCount ? ` are` : ` is`) + ` no longer available.</span>`;
                }
                return text;
            }
        },
        methods: {
            validate: function () {
                return this.$refs.input.validate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/questionnaire_template/select-list.vue